// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","bannerContainer":"mfWXptndrbMtmXOVx26nD","bannerContent":"_1miSt9S4mvQaX6PRTbtLD","error":"XfGpVvXvmWmSrQWfV3Smu"};